import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleSnackBar } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import ProfileAmlLevelDocs from 'apps/auth/components/profile/aml/ProfileAmlLevelDocs';
import UsaAdvancedDocsList from 'apps/auth/components/profile/aml/usa/UsaAdvancedDocsList';
import UsaDocsList from 'apps/auth/components/profile/aml/usa/UsaDocsList';
import BasePage from 'apps/auth/components/utils/BasePage';
import { HOW_TO_SEND_DOCS_SCREEN_SHOWN, OFAKIM_HOW_TO_SEND_DOCS_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { AML_LEVEL_BASIC, AML_LEVEL_STANDARD } from 'apps/auth/constants/Constants';
import { AUTH_PROFILE_AML_LEVELS, AUTH_PROFILE_LIMITS } from 'apps/auth/constants/UrlConstants';
import { ISRAEL, USA } from 'apps/auth/constants/WellKnownCountries';
import { useAuth, useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { UsaService } from 'apps/auth/services/UsaService';

const ProfileAmlLevelDocsPage = (props) => {
    const { notNowButton } = usePageMessages();
    const { profile_form: profile } = useExtra();
    const { countryId } = useAuth();
    const popupRef = useRef(null);

    useEffect(() => {
        amplitude.getInstance().logEvent(HOW_TO_SEND_DOCS_SCREEN_SHOWN);
        if (countryId === ISRAEL) {
            amplitude.getInstance().logEvent(OFAKIM_HOW_TO_SEND_DOCS_SCREEN_SHOWN);
        }
    }, []);

    const newUsaLimits = USA === countryId && UsaService.isNewLimits(profile);
    if (newUsaLimits) {
        const currentLimit = profile?.amlLimit?.currentLimit;
        return (
            <>
                <CommonPage
                    hasBottomPanel
                    showChat={false}
                    rightHeaderComponent={
                        <Button type="link" size="tight" variant="tertiary" href={AUTH_PROFILE_LIMITS} caption={notNowButton} title={notNowButton} />
                    }
                >
                    {currentLimit === AML_LEVEL_BASIC && (
                        <UsaDocsList toggleChat={props.toggleChat} popupRef={popupRef} toggleSnackBar={props.toggleSnackBar} />
                    )}
                    {currentLimit === AML_LEVEL_STANDARD && (
                        <UsaAdvancedDocsList toggleChat={props.toggleChat} popupRef={popupRef} toggleSnackBar={props.toggleSnackBar} />
                    )}
                </CommonPage>
                <PopupNew ref={popupRef} />
            </>
        );
    }

    return (
        <CommonPage backUrl={AUTH_PROFILE_AML_LEVELS} hasBottomPanel showChat={false}>
            <ProfileAmlLevelDocs />
        </CommonPage>
    );
};
export default connect(null, { toggleChat, toggleSnackBar })(BasePage(ProfileAmlLevelDocsPage));
